/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Royalty_FreeInputs */

const en_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Royalty-Free`)
};

const es_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre de regalías`)
};

const fr_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre de droits`)
};

const de_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lizenzfrei`)
};

const ja_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロイヤリティフリー`)
};

const zh_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免版税 (Royalty-Free)`)
};

const ar_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بدون حقوق ملكية (Royalty-Free)`)
};

const id_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bebas Royalti`)
};

const it_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Royalty-Free`)
};

const ru_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без лицензионных платежей`)
};

const pt_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Royalty-Free`)
};

const ko_val_royalty_free = /** @type {(inputs: Val_Royalty_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로열티 프리(RF)`)
};

/**
* | output |
* | --- |
* | "Royalty-Free" |
*
* @param {Val_Royalty_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_royalty_free = /** @type {((inputs?: Val_Royalty_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Royalty_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_royalty_free(inputs)
	if (locale === "es") return es_val_royalty_free(inputs)
	if (locale === "fr") return fr_val_royalty_free(inputs)
	if (locale === "de") return de_val_royalty_free(inputs)
	if (locale === "ja") return ja_val_royalty_free(inputs)
	if (locale === "zh") return zh_val_royalty_free(inputs)
	if (locale === "ar") return ar_val_royalty_free(inputs)
	if (locale === "id") return id_val_royalty_free(inputs)
	if (locale === "it") return it_val_royalty_free(inputs)
	if (locale === "ru") return ru_val_royalty_free(inputs)
	if (locale === "pt") return pt_val_royalty_free(inputs)
	return ko_val_royalty_free(inputs)
});